var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmailEditor',{ref:"emailEditor",staticClass:"unlayerEditorContainer",attrs:{"options":_vm.editorOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }